import React, { PureComponent } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import Rating from 'react-rating'
import { FormattedMessage } from 'react-intl'
import RawHtml from 'stories/components/RawHtml'
import HeartSvg from './HeartSvg'
import StarSvg from './StarSvg'

export default class NpsRating extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputChange = (event) => {
    const { value } = event.target
    this.props.onChange(value)
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => this.props.value

  generateHint = (maxLength = 255) => (
    <span className="form-field-limit">
      (
      <FormattedMessage
        id="form.fields.text.maxLengthHint"
        values={{ maxLength }}
      />
      )
    </span>
  )

  render() {
    const {
      label = '',
      required,
      touched,
      error,
      description,
      SideElement,
      hideTitle,
      thumbnail_type,
      range_end,
    } = this.props

    const classNames = {
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    const emptyIcons = {
      heart: <HeartSvg />,
      star: <StarSvg />,
    }

    const fillIcons = {
      heart: <HeartSvg active />,
      star: <StarSvg active />,
    }
    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          {!hideTitle && (
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>
          )}

          <RawHtml className="formz-field-description" content={description} />
          <div
            className="formz-input-field"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Rating
              value={this.getInputValue()}
              emptySymbol={emptyIcons[thumbnail_type]}
              fullSymbol={fillIcons[thumbnail_type]}
              stop={!range_end ? 5 : range_end}
            />
            {SideElement && <SideElement />}
          </div>
        </label>
      </FieldRowWrapper>
    )
  }
}
